<app-table
  (focusDateChange)="focusDateChange($event)"
  [columns]="columns"
  [focusDate]="focusDate"
  [hasFocusDate]="true"
  [loading]="loading"
  [value]="organisations"
  dataKey="organisationId"
  filename="MENU.ORGANISATIONAL_UNITS"
  sortField="organisationId">
  @if (isManager()) {
    <ng-template
      (onClick)="addNewOrganisationalUnit()"
      appToolbarButton
      icon="fal fa-plus"
      labelKey="ORGANISATIONAL_UNITS.TITLE_CREATE"></ng-template>
  }
  @if (isManager()) {
    <ng-template
      (onClick)="delete($event.row)"
      [width]="150"
      appActionButton
      displayIf="deletable"
      icon="fal fa-trash"
      labelKey="ACTIONS.DELETE"
      type="danger"></ng-template>
  }
</app-table>
